import React from 'react'
import './PaperFoldBox.scss'
import {
  FirebaseService,
  FirebaseConfigKey,
} from '../../services/FirebaseService'
var classNames = require('classnames')

export const PriceWithComma = ({ price, ...props }) => {
  return (
    <span {...props}>
      {FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}
      {price.toLocaleString('en-US')}
    </span>
  )
}
